// extracted by mini-css-extract-plugin
export var cardContainer = "_my-0";
export var cardHeader = "_my-2";
export var collapsedState = "_my-3";
export var dragHandle = "_my-5";
export var dragHandleIcon = "_my-6";
export var dragging = "_my-1";
export var titleArea = "_my-4";